import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.baseUrl}/permission`,{params:searchParams});
    }

    get(id){
      return this.http.get(`${environment.baseUrl}/permission/`+id);
    }

    edit(id,formData){
      return this.http.put(`${environment.baseUrl}/permission/`+id,formData);
    }

    create(formData){
      return this.http.post(`${environment.baseUrl}/permission`,formData);
    }

    delete(id){
      return this.http.delete(`${environment.baseUrl}/permission/`+id);
    }

}
